import { Badge, Dropdown } from 'antd';
import React, { memo, useMemo } from 'react';
import * as Icon from 'react-feather';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { imgAvatar } from '@assets/images';
import CONFIG from '@config';
import store from '@core/store/redux';
import { RootState } from '@modules';
import { removeProfile } from '@modules/authentication/profileStore';
import UserEntity from '@modules/user/entity';
import { Selector } from '@reduxjs/toolkit';
import ChangeLanguage from '@shared/components/ChangeLanguage';
import { DeleteConfirm } from '@shared/components/ConfirmDelete';
import { useAltaIntl } from '@shared/hook/useTranslate';

interface IHeaderComponent {
  profile?: UserEntity;
}

interface IChangeLanguage {
  language: string;
}

const HeaderComponentSelector: Selector<RootState, IHeaderComponent> = (state: RootState) => {
  return {
    profile: state.profile.user,
  };
};
const ChangeLanguageSelector: Selector<RootState, IChangeLanguage> = (state: RootState) => ({
  language: state.settingStore.language,
});

const HeaderComponent = () => {
  const { profile } = useSelector(HeaderComponentSelector);
  const navigate = useNavigate();
  const { formatMessage } = useAltaIntl();
  const { language } = useSelector(ChangeLanguageSelector);

  const items = useMemo(() => {
    return [
      { key: '0', label: formatMessage('profile.info') },
      // { key: '1', label: formatMessage('profile.edit') },
      {
        key: '2',
        label: (
          <div className="d-flex justify-content-between align-items-center">
            <span className="menu-label">{formatMessage('common.logout')}</span>
            <Icon.LogOut className="menu-label" />
          </div>
        ),
      },
    ];
  }, [language]);

  const onMenuSelect = ({ key }: any) => {
    switch (key) {
      case '0':
        navigate({ pathname: '/profile', search: 'status=info' });
        break;
      case '1':
        navigate({ pathname: '/profile', search: 'status=edit' });
        break;
      case '2':
        DeleteConfirm({
          title: formatMessage('common.logout.title'),
          content: formatMessage('common.logout.content'),
          handleOk: () => {
            window.location.href = CONFIG.LOGIN_PAGE;
            store.dispatch(removeProfile());
          },
        });
        break;
      default:
        return;
    }
  };

  return (
    <>
      <div className="header-component">
        <div className="header-component__search">
          <ChangeLanguage />
        </div>
        <div className="notification-badge">
          <Badge count={9} overflowCount={10}>
            <Icon.Bell />
          </Badge>
        </div>
        <div className="header-component__dropdown">
          <div className="dropdown__profile__img">
            <img alt="img-avatar" className="img-avatar" src={profile?.avatarPath || imgAvatar} />
          </div>
        </div>
        <Dropdown
          menu={{ items, onClick: onMenuSelect }}
          placement="bottomRight"
          trigger={['click']}
          overlayClassName={'header-component__dropdown-menu'}
        >
          <div className="d-flex align-items-center">
            <div className="header-component__identify">
              <h4 className="identify__admin">{profile?.fullName}</h4>
              <p className="identify__hi">{(profile && profile?.email) || 'Unknown'}</p>
            </div>
            <a onClick={e => e.preventDefault()} className="header-component__down-icon">
              <Icon.ChevronDown />
            </a>
          </div>
        </Dropdown>
      </div>
    </>
  );
};

export default memo(HeaderComponent);
